module.exports = __webpack_public_path__ + "static/media/icon03.a4f74077.svg";